export default __webpack_public_path__ + "static/media/Mountain Bike.02b9a146.jpg";